import React from 'react';
const DateComparatorFilter = (filterLocalDateAtMidnight, cellValue) => {
  // Extract local date components from filterLocalDateAtMidnight
  const filterYear = filterLocalDateAtMidnight.getFullYear();
  const filterMonth = filterLocalDateAtMidnight.getMonth();
  const filterDay = filterLocalDateAtMidnight.getDate();

  // Parse the cellValue into local date components
  const cellDateParts = cellValue.split(/[\/-]/);
  if (cellDateParts.length === 3) {
    const cellYear = parseInt(cellDateParts[0]);
    const cellMonth = parseInt(cellDateParts[1]) - 1; // Months are 0-based in JavaScript
    const cellDay = parseInt(cellDateParts[2]);

    // Create local dates for comparison
    const filterDate = new Date(filterYear, filterMonth, filterDay).getTime();
    const cellDate = new Date(cellYear, cellMonth, cellDay).getTime();

    // Compare the dates
    if (filterDate === cellDate) {
      return 0; // Dates are equal
    }
    if (cellDate < filterDate) {
      return -1; // Cell date is before filter date
    }
    if (cellDate > filterDate) {
      return 1; // Cell date is after filter date
    }
  }

  return 0; // Default return if parsing fails
};

export default DateComparatorFilter;
